/* eslint-disable no-unused-vars */
import WorkerService from "@/services/worker";

import { SET_WORKERS } from "./types";

export async function getWorkers({commit}, params) {
  const {data} = await WorkerService.get(params);
  const workers = data.data;
  commit(SET_WORKERS, workers);
  return workers;
}

export async function setGroup({commit}, params) {
  const {data} = await WorkerService.setGroup(params);
  const workers = data.data;
  commit(SET_WORKERS, workers);
  return workers;
}

export async function addGroup({commit}, group) {
  const {data} = await WorkerService.addGroup(group);
  const groups = data.data;
  return groups;
}

export async function getGroupList() {
  const {data} = await WorkerService.getGroupList();
  return data.data;
}

export async function getIpList() {
  const {data} = await WorkerService.getIpList();
  return data.data;
}

export async function disconnect({commit}, worker_uids) {
  const {data} = await WorkerService.disconnect({ worker_uids });
  return data;
}

export async function reload({commit}, worker_uids) {
  const {data} = await WorkerService.reload({ worker_uids });
  return data;
}

export async function openWindow({commit}, worker_uids) {
  const {data} = await WorkerService.openWindow({ worker_uids });
  return data;
}

export async function closeWindow({commit}, worker_uids) {
  const {data} = await WorkerService.closeWindow({ worker_uids });
  return data;
}